module.exports = __webpack_public_path__ + "img/国家高新技术企业.94aea08f.jpg";